import styled from 'styled-components';

import { BasicParagraph, BiggerSubtitle, style } from '@genially/design-system';

export const ButtonsWrapper = styled.div(({ theme: { size } }) => ({
  flex: '1 1 0',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: size.units(),

  ...style.mixins.responsive.xs.downward({
    flexDirection: 'column-reverse',
    width: '100%',

    '> button': {
      width: '100%',
    },
  }),
}));

export const StyledBiggerSubtitle = styled(BiggerSubtitle)(() => ({
  textAlign: 'center' as const,
}));

export const StyledBasicParagraph = styled(BasicParagraph)(() => ({
  textAlign: 'center' as const,
}));

export const ContentWrapper = styled.div(({ theme: { size } }) => ({
  padding: `${size.units(2)} 0`,
}));
